import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Challenges from "@/pages/Challenges";
import Gallery from "@/pages/Gallery";
import Admin from "@/pages/Admin";
import RaceCalendar from "@/pages/RaceCalendar";
import AskFitygrity from "@/pages/AskFitygrity";
import StravaCallback from "@/pages/StravaCallback";
import Events from "@/pages/Events";
import Expeditions from "@/pages/Expeditions";
import Journal from "@/pages/Journal";
import Article from "@/pages/Article";
import Articles from "@/pages/Articles";
import ArticleDetail from "@/pages/ArticleDetail";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import Community from "@/pages/Community";
import About from "@/pages/About";
import Leadership from "@/pages/Leadership";
import Contact from "@/pages/Contact";
import ChallengeDetail from "@/pages/ChallengeDetail";
import TrainingHub from "@/pages/TrainingHub";
import Profile from "@/pages/Profile";
import Signup from "@/pages/Signup";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.25,
      smoothWheel: true,
      anchors: true,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App bg-[#FBF9F5] text-[#0D1117] min-h-screen">
      <div className="grain-overlay" aria-hidden="true" />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/challenges" element={<Challenges />} />
          <Route path="/challenges/:slug" element={<ChallengeDetail />} />
          <Route path="/events" element={<Events />} />
          <Route path="/expeditions" element={<Expeditions />} />
          <Route path="/journal" element={<Journal />} />
          <Route path="/journal/:slug" element={<Article />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/articles/:slug" element={<ArticleDetail />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/training" element={<TrainingHub />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/community" element={<Community />} />
          <Route path="/about" element={<About />} />
          <Route path="/leadership" element={<Leadership />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/calendar" element={<RaceCalendar />} />
          <Route path="/ask" element={<AskFitygrity />} />
          <Route path="/auth/strava/callback" element={<StravaCallback />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            border: "1px solid rgba(255, 78, 0, 0.35)",
            color: "#0D1117",
          },
        }}
      />
    </div>
  );
}
